"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Builder = _interopRequireDefault(require("./Builder"));
var _settings = require("./Builder/settings.js");
var _Player = _interopRequireDefault(require("./Player"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = {
  code: 'menuItem',
  name: 'Menu Item',
  icon: _settings.icon,
  builder: _Builder["default"],
  builderInitialValues: _settings.initialValues,
  player: _Player["default"],
  previewButtons: ['undo', 'redo', 'duplicate', 'delete'],
  isStaticPlayer: true,
  isAdult: true,
  skipPlaying: true,
  ttsFields: _settings.ttsFields,
  isParentAllowed: function isParentAllowed(parentType) {
    return parentType === 'menu';
  },
  onDrop: function onDrop() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      parentId = _ref.parentId;
    if (!parentId) {
      (0, _cccisdNotification["default"])({
        message: 'You have to drag "Menu Item" into the element tree',
        type: 'warning',
        duration: 10000
      });
      return false;
    }
    return true;
  }
};
exports["default"] = _default;